export interface IMediaPropertyValue {
  mediaId: number | null;
  url: string;
}

export class MediaValueHelper {
  public static parse(value: string | null | undefined): IMediaPropertyValue | null {
    if (!value) {
      return null;
    }

    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }

    if (!trimmed.startsWith("{")) {
      return {
        mediaId: null,
        url: trimmed
      };
    }

    try {
      const parsed = JSON.parse(trimmed) as Partial<IMediaPropertyValue>;
      if (typeof parsed.url === "string" && parsed.url.trim().length > 0) {
        return {
          mediaId: typeof parsed.mediaId === "number" ? parsed.mediaId : null,
          url: parsed.url
        };
      }
    } catch {
      return {
        mediaId: null,
        url: trimmed
      };
    }

    return null;
  }

  public static getUrl(value: string | null | undefined): string {
    return this.parse(value)?.url ?? "";
  }

  public static create(mediaId: number | null, url: string): string {
    return JSON.stringify({
      mediaId,
      url
    });
  }
}
